import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../Navbar";
import Footer from "../components/Footer";
import CookiesBanner from "../components/CookiesBanner";

const CODIGO =
  "javascript:(function(){window.open('https://www.avisamesibaja.com/?url='+encodeURIComponent(location.href),'_blank');})();";

const caja = {
  maxWidth: "720px",
  margin: "0 auto",
  padding: "2rem",
  lineHeight: 1.6,
  fontSize: "16px",
};

export default function Bookmarklet() {
  const enlaceRef = useRef(null);
  const [copiado, setCopiado] = useState(false);

  // React no permite renderizar un href "javascript:", así que se asigna
  // directamente sobre el nodo una vez montado.
  useEffect(() => {
    if (enlaceRef.current) enlaceRef.current.setAttribute("href", CODIGO);
  }, []);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(CODIGO);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    } catch {
      setCopiado(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Botón "Avísame si baja" para tu navegador</title>
        <meta
          name="description"
          content="Añade un botón a tu navegador y vigila el precio de cualquier producto de Amazon con un solo clic."
        />
      </Helmet>
      <Navbar />

      <div style={caja}>
        <h1>Vigila cualquier producto con un clic</h1>
        <p>
          Para seguir un producto tienes que copiar su enlace de Amazon, volver aquí y
          pegarlo. Con este botón te ahorras todo eso: lo pulsas mientras estás en
          Amazon y nosotros rellenamos el enlace por ti.
        </p>

        <h2>Cómo instalarlo</h2>
        <ol>
          <li>
            Asegúrate de que se ve la barra de marcadores de tu navegador
            (<strong>Ctrl+Mayús+B</strong> en Windows, <strong>Cmd+Mayús+B</strong> en Mac).
          </li>
          <li>Arrastra este botón hasta esa barra:</li>
        </ol>

        <div style={{ textAlign: "center", margin: "1.8rem 0" }}>
          <a
            ref={enlaceRef}
            href="/bookmarklet"
            onClick={(e) => e.preventDefault()}
            style={{
              display: "inline-block",
              background: "#ff9900",
              color: "#111",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "1.05em",
              padding: "14px 34px",
              borderRadius: "6px",
              cursor: "grab",
            }}
          >
            🔔 Avísame si baja
          </a>
          <p style={{ fontSize: "0.85em", color: "#666", marginTop: "0.7rem" }}>
            Arrástralo, no lo pulses aquí: solo funciona desde una página de Amazon.
          </p>
        </div>

        <ol start={3}>
          <li>
            Cuando estés viendo un producto en Amazon, pulsa el marcador. Se abrirá
            esta web con el enlace ya puesto y solo tendrás que guardar la alerta.
          </li>
        </ol>

        <h2>Si no puedes arrastrarlo</h2>
        <p>
          Crea un marcador nuevo a mano, ponle el nombre que quieras y pega este texto
          en el campo de la dirección:
        </p>
        <textarea
          readOnly
          value={CODIGO}
          onFocus={(e) => e.target.select()}
          style={{
            width: "100%",
            minHeight: "70px",
            fontFamily: "monospace",
            fontSize: "0.82em",
            padding: "0.7rem",
            border: "1px solid #ccc",
            borderRadius: "6px",
            resize: "vertical",
          }}
        />
        <button
          onClick={copiar}
          style={{
            marginTop: "0.6rem",
            padding: "0.5rem 1.1rem",
            border: "1px solid #235470",
            borderRadius: "6px",
            background: copiado ? "#1a6b3a" : "#235470",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          {copiado ? "✅ Copiado" : "Copiar código"}
        </button>

        <p style={{ fontSize: "0.9em", color: "#666", marginTop: "2rem" }}>
          <strong>Nota:</strong> los marcadores de este tipo funcionan en ordenador
          (Chrome, Firefox, Edge, Safari). En el móvil no se pueden usar: ahí lo más
          cómodo sigue siendo copiar el enlace de Amazon y pegarlo en la web.
        </p>
      </div>

      <Footer />
      <CookiesBanner />
    </>
  );
}
